import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { setCommercialDetails } from "../../../Redux/actions/CommercialSlice";
import {
  Form,
  Row,
  Col,
  AutoComplete,
  Button,
  DatePicker,
  Input,
  Radio,
  Select,
} from "antd/lib";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
import {
  getCommercialDetails,
  getComQuickQuotePost,
} from "../../../Redux/actions/CommercialSlice";
import moment from "moment";
// import "./commercial.css";

const VehicleEdit = () => {
  const { Ctype } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const QuickQuotePost = useSelector(getComQuickQuotePost);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const CommercialDetails = useSelector(getCommercialDetails);
  const commercialnum = useSelector(
    (state) => state?.commercialdetail?.commercialnum
  );
  const BikeMakeData = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );
  const [loading, setLoading] = useState(false);
  const [saveloading, setIsaveloading] = useState(false);
  const [options, setOptions] = useState([]);
  const [typesData, setTypedata] = useState([]);
  const [TypeOption, setTypeOption] = useState([]);
  // const [comVehicleType, setVehicleType] = useState('');
  const [MakeData, setMakeData] = useState([]);
  const [CommerMake, setCommerMake] = useState(CommercialDetails?.make ?? "");
  const [ModalData, setModalData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [commerModel, setModelSearch] = useState(
    CommercialDetails?.model ?? ""
  );
  const [VarientData, setVarientData] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  const [comTypeName, setcomTypeName] = useState("");
  const [commercialVarient, setSelectVarient] = useState("");
  const [carrierType, setCarrierType] = useState("PUBLIC");

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  useEffect(() => {
    form.setFieldsValue({
      commercial_vehicle_number: commercialnum?.commercial_vehicle_number,
    });
  }, [vechicleData, commercialnum, Ctype]);

  useEffect(() => {
    axiosCommercial
      .get("commercial_vehicle_type")
      .then((res) => {
        console.log(res);
        const resp = res.data.data;
        console.log(resp);
        const typeData = resp.map((item) => item);
        console.log("resp", typeData);
        const filteredOptions = typeData.map((option) =>
          option.types.toUpperCase()
        );
        console.log("filteredOptions", filteredOptions);
        setTypedata(filteredOptions);
        setTypeOption(filteredOptions);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleSearchcomMake = (searchText) => {
    // setLoading(true)
    setIsaveloading(true);
    const filteredOptions = TypeOption.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    console.log(filteredOptions);
    setTypedata(filteredOptions);
  };
  // const onSelectCommeType = (data) => {
  //   console.log("onSelect", data);
  //   setcomTypeName(data);
  //   setVehicleType(data);
  //   // setIsaveloading(false);
  //   form.setFieldsValue({
  //     commercialMake: "",
  //     commercialModel: "",
  //     commercialVarient: "",
  //   });
  // };

  useEffect(() => {
    axiosCommercial
      .get(`vehicle_masters?product_type=${CommercialDetails?.commercialType}`)
      .then((res) => {
        console.log(res);
        const resp = res.data.makes;
        console.log(resp);
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [CommercialDetails]);
  const handleSearchMake = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = Makeoptions.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    console.log(filteredOptions);
    setMakeData(filteredOptions);
  };

  const onSelectMake = (data) => {
    console.log("onSelect", data);
    setCommerMake(data);
    dispatch(
      setCommercialDetails({
        ...CommercialDetails,
        make: data,
        model: null,
        varient: null,
      })
    );
    // const updatedVahanData = {
    //   ...vechicleData,
    //   maker_description: data,
    // };
    // dispatch(addVahanData(updatedVahanData));
    setIsaveloading(false);
    form.setFieldsValue({
      commercialModel: "",
      commercialVarient: "",
    });
  };
  useEffect(() => {
    axiosCommercial
      .get(
        `vehicle_masters?product_type=${CommercialDetails?.commercialType}&make=${CommerMake}`
      )
      .then((res) => {
        console.log(res);
        const resp = res.data.models;
        console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [CommerMake]);

  const handleSearch = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setModalData(filteredOptions);
  };

  const onSelect = (data) => {
    console.log("onSelect", data);
    setModelSearch(data);
    dispatch(
      setCommercialDetails({
        ...CommercialDetails,
        model: data,
      })
    );
    setIsaveloading(false);
    // const updatedVahanData = {
    //   ...vechicleData,
    //   maker_model: data,
    // };
    // dispatch(addVahanData(updatedVahanData));
    form.setFieldsValue({
      commercialVarient: "",
    });
  };

  useEffect(() => {
    axiosCommercial
      .get(
        `vehicle_masters?product_type=${CommercialDetails?.commercialType}&make=${CommerMake}&model=${commerModel}`
      )
      .then((res) => {
        console.log(res);
        const resp = res.data.variants;
        console.log(resp);
        const varientData = resp.map((item) => item);
        // console.log("resp", varientData);
        setVarientOptions(varientData);
        setVarientData(varientData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [commerModel]);

  const handleSearchVarient = (searchText) => {
    setIsaveloading(true);
    searchText = searchText.toUpperCase();
    form.setFieldsValue({ commercialVarient: searchText });
    const filteredOptions = VarientOption.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setVarientData(filteredOptions);
  };

  const onFinish = (values) => {
    setLoading(true);
    console.log(values);
    dispatch(
      setCommercialDetails({
        ...CommercialDetails,
        licensePlate: values?.commercial_vehicle_number,
        RegYear: moment(values?.registrationYear).format("YYYY-MM-DD"),
      })
    );
    // history.push(`/commercial/${Ctype}/details`);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handlePermitChange = (e) => {
    console.log("Selected Permit Type:", e.target.value);
    const value = e.target.value;
    setCarrierType(value);
    dispatch(
      setCommercialDetails({
        ...CommercialDetails,
        permitType: value,
      })
    );
  };
  const VarientChange = (variant, option) => {
    console.log(variant, option);
    setSelectVarient(variant);
    axiosCommercial
      .get(
        `vehicle_masters?product_type=${CommercialDetails?.commercialType}&make=${CommerMake}&model=${commerModel}&variant=${variant}`
      )
      .then((res) => {
        const resp = res?.data;
        // console.log(resp);
        dispatch(
          setCommercialDetails({
            ...CommercialDetails,
            vehicleCoreCode: resp?.vehicle_core_code,
            varient: option?.label,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
    setIsaveloading(false);
  };
  return (
    <>
      <div className="row align-items-start justify-content-between">
        <Form
          layout={formLayout}
          form={form}
          className="ant-quote-form col-xl-12 col-lg-12 col-md-12"
          requiredMark={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={24}>
            <Col span={14}>
              <Form.Item
                // {...formItemLayout}
                label="Vehicle Number"
                name="commercial_vehicle_number"
                rules={[
                  {
                    pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                    message: "Invalid Vehicle No",
                  },
                  { required: true, message: "Enter Vehicle No" },
                ]}
              >
                <Input
                  //onChange={handleInputChange}
                  placeholder="Enter Vehicle Number (eg. DL1SAB1234)"
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label="Carrier Type"
                name="permit_type"
                rules={[{ required: true, message: "select Permit Type" }]}
                initialValue="PUBLIC"
                style={{ lineHeight: "5" }}
              >
                <Radio.Group
                  className="permit-grp"
                  onChange={handlePermitChange}
                  value={carrierType}
                >
                  <Radio
                    value="PRIVATE"
                    style={{
                      height: "40px",
                      lineHeight: "40px",
                      fontSize: "14px",
                    }}
                    className="custom-radio-btn"
                  >
                    Private
                  </Radio>
                  <Radio
                    value="PUBLIC"
                    style={{
                      height: "40px",
                      lineHeight: "40px",
                      fontSize: "14px",
                    }}
                    className="custom-radio-btn"
                  >
                    Public
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="commercialMake"
                label="Select Make"
                rules={[
                  {
                    required: true,
                    message: "Please Select Make",
                  },
                ]}
                initialValue={CommercialDetails?.make}
              >
                <AutoComplete
                  options={MakeData?.map((p, index) => ({
                    key: index,
                    value: p,
                    label: p,
                  }))}
                  onSelect={onSelectMake}
                  onSearch={handleSearchMake}
                  placeholder="Enter Make"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="commercialModel"
                label="Select Model"
                rules={[
                  {
                    required: true,
                    message: "Please Select Model",
                  },
                ]}
                initialValue={CommercialDetails?.model}
              >
                <AutoComplete
                  options={ModalData?.map((p, index) => ({
                    key: index,
                    value: p,
                    label: p,
                  }))}
                  onSelect={onSelect}
                  onSearch={handleSearch}
                  placeholder="Enter Model"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="commercialVarient"
                label="Select Variant"
                rules={[
                  {
                    required: true,
                    message: "Please Select Variant",
                  },
                ]}
                initialValue={CommercialDetails?.varient}
              >
                <Select
                  placeholder="Select Variant"
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={VarientData?.map((p, index) => ({
                    key: index,
                    value: p.variant,
                    label: p.customized_variant,
                  }))}
                  onChange={(variant, option) => VarientChange(variant, option)}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                {...formItemLayout}
                label="Registration Year"
                name="registrationYear"
                initialValue={
                  QuickQuotePost?.registrationDate
                    ? moment(QuickQuotePost?.registrationDate)
                    : null
                }
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  placeholder="Select Registration Date"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item {...buttonItemLayout}>
                <Button
                  style={{ width: "100%" }}
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                >
                  Update
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};
export default VehicleEdit;
